export const roamData = {
    projectHeading: 'The ROAM Project',
    projectMainImage: {
        image: '/images/portfolio/roam-maps/roam.jpg',
        alt: 'Roam Portfolio Banner'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/roam-maps/app-instructions.png',
            image: '/images/portfolio/roam-maps/app-instructions-thumb.png',
            alt: 'ROAM Product Instructions'
        },
        {
            fullImage: '/images/portfolio/roam-maps/blog.png',
            image: '/images/portfolio/roam-maps/blog-thumb.png',
            alt: 'ROAM Blog'
        },
        {
            fullImage: '/images/portfolio/roam-maps/get-the-app.png',
            image: '/images/portfolio/roam-maps/get-the-app-thumb.png',
            alt: 'App Overview Page'
        },
        {
            fullImage: '/images/portfolio/roam-maps/get-the-chip.png',
            image: '/images/portfolio/roam-maps/get-the-chip-thumb.png',
            alt: 'Chip Overview Page'
        },
        {
            fullImage: '/images/portfolio/roam-maps/mobile-products.png',
            image: '/images/portfolio/roam-maps/mobile-products-thumb.png',
            alt: 'Mobile Products Page'
        },

        {
            fullImage: '/images/portfolio/roam-maps/product-page.png',
            image: '/images/portfolio/roam-maps/product-page-thumb.png',
            alt: 'Product Page'
        },
        {
            fullImage: '/images/portfolio/roam-maps/product-page-mobile.png',
            image: '/images/portfolio/roam-maps/product-page-mobile-thumb.png',
            alt: 'Product Page Mobile'
        },
        {
            fullImage: '/images/portfolio/roam-maps/redeem.png',
            image: '/images/portfolio/roam-maps/redeem-thumb.png',
            alt: 'Redeem Gift Card Page'
        },
        {
            fullImage: '/images/portfolio/roam-maps/store.png',
            image: '/images/portfolio/roam-maps/store-thumb.png',
            alt: 'Store Page'
        },
    ],
    aboutHeading: 'About The ROAM Project',
    aboutPortfolioText: [
        `ROAM maps is the outdoor adventure digital maps division of onXmaps. The company focused on making digital outdoor maps for people
         to use on their Garmin GPS or phone while on their adventure in the outdoors. Specifically, ROAM focused on maps for backpackers,
         hikers, and outdoor enthusiast, while it's sister, HuntingGPSMaps, focused primarily on maps for hunters (all under the onXmaps umbrella).`,

        `ROAM was built on top of the success of HuntingGPSMaps. With the hunting map market dominated by HuntingGPSMaps, the company felt it was
         a great time to expand and create a second brand (called ROAM), and explore potential revenue streams in the outdoor map market.`
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of ROAM was to be built leveraged many of the same technologies as HuntingGPSMaps, while having the advanced features of it's parent
         site, onXmaps. ROAM was built as an e-commerce solution leveraging the existing Magento storefront. This allowed customers to purchase physical and digital products,
         and to maintain their subscriptions through the site.`
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Provide a way for customer to purchase physical and digital products`,
        `Allow the user to manage their digital subscription`,
        `Allow a way for the user to update their digital maps through an in-house update tool`,
        `Have a blog where content creators could create interesting content on a weekly basis`,
        `Create strong SEO to drive organic traffic to the site through search engines`,
        `Include tools to analyze user's flow and click through rates`,
        `Provide tutorials to inform users how to troubleshoot and use their digital maps`,
        `Be built on-top-of existing HuntingGPSMaps technology while looking modern like onXmaps`
    ],
    myRoleHeading: 'My Role On The ROAM GPS Maps Project',
    position: 'Lead Web Developer',
    company: 'onXmaps Inc.',
    timeWithCompany: '3 years, 5 months',
    myRoleText: [
        `As the primary lead developer on this project, I had a lot of responsibilities. As part of these responsibilities, I was meeting with the
         Marketing Manager and the Chief Technology Office to determine the requirements for this project. In many cases, I ended up laying out the design for the pages as the
         marketing team was short-staffed.`,

        `I lead my team in the development and deployment of this project.  I was responsible for all technical decisions, including but not limited to: tech stack, implementation,
         database schemas, and how it tied into the rest of the overall onXmaps system.`
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working on the Hunting GPS Maps project',
    jobSummaryList: [
        `Build/Manage E-Commerce Database`,
        `Train Junior Developers`,
        `Build new features into the system`,
        `Tie in third party features (UserVoice, MailChimp, etc.)`,
        `Work closely with the marketing team for the implementation of marketing campaigns`,
        `Write requirements, design mockups, and facilitate projects with Third Party Web Development Contractors`,
        `Architect the database system to tie into the onXmaps system`,
        `Deploy seamless updates to the website`,
        `Meet with stakeholders to discuss new features`,
        `Sift through analytical data to determine bottlenecks for customers`,
        `Improve SEO on website`,
        `Design and lay out web pages`,
        `Update SSL and Server Configurations through third party hosted dedicated server`,
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the onXmaps website. The site was originally architected and built by myself, with mockups coming from the design department.`,
    technologiesList: [
        `HTML5`,
        `JavaScript`,
        `CSS3`,
        `Magento 1.9`,
        `UserVoice`,
        `PHP`,
        `Git`,
        `Sass`,
        `jQuery`,
        `MailChimp Newsletter`,
        `Twitter Bootstrap`,
        `Google Analytics`,
        `Photoshop`,
        `Skrollr`,
        `Responsive Design`,
        `Red Hat Server`,
        `Illustrator`
    ]
}